export const cleanNumberInput = (value, maxDigits) => {
  if (!value) return "";

  const numbers = value.replace(/\D/g, "");

  return numbers.slice(0, maxDigits);
};

export const validateCPF = (cpf) => {
  const digits = cpf.replace(/\D/g, "");
  if (digits.length !== 11) return false;
  if (/^(\d)\1{10}$/.test(digits)) return false;

  const calc = (len) => {
    let sum = 0;
    for (let i = 0; i < len; i++) {
      sum += parseInt(digits[i], 10) * (len + 1 - i);
    }
    const remainder = sum % 11;
    return remainder < 2 ? 0 : 11 - remainder;
  };

  return calc(9) === parseInt(digits[9], 10) && calc(10) === parseInt(digits[10], 10);
};

export const formatCPF = (value) => {
  const numbers = value.replace(/\D/g, "").slice(0, 11);
  return numbers.replace(
    /(\d{3})(\d{3})(\d{3})(\d{0,2})/,
    (match, p1, p2, p3, p4) =>
      p4 ? `${p1}.${p2}.${p3}-${p4}` : `${p1}.${p2}.${p3}`
  );
};

export const validateCNPJ = (cnpj) => {
  const digits = cnpj.replace(/\D/g, "");
  if (digits.length !== 14) return false;
  if (/^(\d)\1{13}$/.test(digits)) return false;

  const calc = (len, weights) => {
    let sum = 0;
    for (let i = 0; i < len; i++) sum += parseInt(digits[i], 10) * weights[i];
    const r = sum % 11;
    return r < 2 ? 0 : 11 - r;
  };

  const w1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
  const w2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

  return (
    calc(12, w1) === parseInt(digits[12], 10) &&
    calc(13, w2) === parseInt(digits[13], 10)
  );
};

export const validateCpfCnpj = (value) => {
  const digits = value.replace(/\D/g, "");
  if (digits.length === 11) return validateCPF(digits);
  if (digits.length === 14) return validateCNPJ(digits);
  return false;
};

export const formatCNPJ = (value) => {
  const numbers = value.replace(/\D/g, "").slice(0, 14);
  return numbers.replace(
    /(\d{2})(\d{3})(\d{3})(\d{4})(\d{0,2})/,
    (_, p1, p2, p3, p4, p5) =>
      p5 ? `${p1}.${p2}.${p3}/${p4}-${p5}` : `${p1}.${p2}.${p3}/${p4}`
  );
};

export const formatCpfCnpj = (value) => {
  const digits = value.replace(/\D/g, "").slice(0, 14);
  if (digits.length <= 11) return formatCPF(digits);
  return formatCNPJ(digits);
};

export const formatPhone = (value) => {
  const numbers = value.replace(/\D/g, "").slice(0, 11);
  if (numbers.length > 10) {
    return numbers.replace(/(\d{2})(\d{5})(\d{0,4})/, (match, p1, p2, p3) =>
      p3 ? `(${p1}) ${p2}-${p3}` : `(${p1}) ${p2}`
    );
  } else {
    return numbers.replace(/(\d{2})(\d{4})(\d{0,4})/, (match, p1, p2, p3) =>
      p3 ? `(${p1}) ${p2}-${p3}` : `(${p1}) ${p2}`
    );
  }
};

export const formatCEP = (value) => {
  if (value == null) return "";

  const str = typeof value === "string" ? value : String(value);
  const numbers = str.replace(/\D/g, "").slice(0, 8);

  return numbers.replace(/(\d{5})(\d{0,3})/, (match, p1, p2) =>
    p2 ? `${p1}-${p2}` : p1
  );
};

export const formatUsername = (value) => {
  return value.replace(/[^\w]/g, "");
};

export const formatNumero = (value) => {
  return value.replace(/\D/g, "");
};

export const formatDate = (dateString) => {
  if (!dateString) return "";
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};

export function parseDateWithoutTimezone(dateString) {
  if (!dateString) return null;
  const [year, month, day] = dateString.split("-");
  return new Date(year, month - 1, day);
}

export function formatarEnderecoLicenca(endereco) {
  if (!endereco) return "";

  const rua = String(endereco.rua || "").trim();
  const municipio = String(endereco.municipio || "").trim();
  const estado = String(endereco.estado || "").trim();
  const numeroInformado =
    endereco.numero !== null &&
    endereco.numero !== undefined &&
    String(endereco.numero).trim() !== "";
  const numero = numeroInformado ? String(endereco.numero).trim() : "S/N";

  if (!rua && !municipio && !estado && !numeroInformado) {
    return "";
  }

  return [rua, numero, municipio, estado].filter(Boolean).join(" - ");
}

export const formatDateToShow = (dateString) => {
  const options = {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  };
  return new Date(dateString).toLocaleDateString("pt-BR", options);
};
